/**
 * The shared class lists of the design system. Every control focuses the same way and is at
 * least 44 px tall, which is what a thumb needs on the phone this app is read on.
 */
export const focusRingClass =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent';

export const cardClass = 'rounded-xl border border-border bg-surface p-4 shadow-xs sm:p-6';

const controlClass = `min-h-11 rounded-lg ${focusRingClass}`;

export const buttonClass = `${controlClass} inline-flex items-center justify-center px-4 text-sm font-medium transition-colors disabled:opacity-60`;

export const primaryButtonClass = `${buttonClass} bg-accent text-accent-ink hover:bg-accent-strong`;

export const secondaryButtonClass = `${buttonClass} border border-border-strong hover:bg-surface-sunken`;

export const inputClass = `${controlClass} w-full border border-border-strong bg-surface px-3 text-ink placeholder:text-ink-subtle`;

export const labelClass = 'text-sm font-medium text-ink-muted';

/** A fieldset's legend: the group's own heading, a step above the labels inside it. */
export const legendClass = 'mb-1 text-sm font-semibold text-ink';

export const hintClass = 'text-sm text-ink-muted';

/** A link inside running text, where the underline is the affordance. */
export const linkClass = `rounded-xs underline decoration-border-strong underline-offset-2 hover:decoration-ink ${focusRingClass}`;

/** Fields stack on a phone and line up from `sm` on. */
export const fieldGridClass = 'grid gap-3 sm:grid-cols-2 lg:grid-cols-3';

/** A form's submit row: full width where the screen is narrow. */
export const submitClass = `${primaryButtonClass} w-full sm:w-auto`;
